<template>
	<div>
		<h1 style="margin-top: 20%; margin-left:auto; margin-right: auto; color: black;">Cash Out Finished</h1>
	</div>
</template>

<script>
export default {
	name: "CashOutFinished",
	props:{

	},
	data() {
		return {

		};
	},
	watch: {},
	created() {
		let urlParams = new URLSearchParams(window.location.search);
		let status = urlParams.get('ppp_status')?.toUpperCase();

		if(status == "OK") {
			let pppEvent = new CustomEvent("transactionComplete", { detail: status });
			window.parent.document.dispatchEvent(pppEvent);
		}
		if(status == "PENDING") {
			let pppEvent = new CustomEvent("transactionComplete", { detail: status });
			window.parent.document.dispatchEvent(pppEvent);
		}
		if(status == "FAIL") {
			let pppEvent = new CustomEvent("transactionComplete", { detail: status });
			window.parent.document.dispatchEvent(pppEvent);
		}

	},
	mounted(){
	},
	methods:{
	},
	
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

p{
	color: black;
}


</style>
